var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import LinkBroken02Svg from './link-broken-02.icon.svg';
export const LinkBroken02Icon = (iconInstanceProps) => {
    return _jsx(Icon, { ...iconInstanceProps, SvgComponent: LinkBroken02Svg });
};
_react_refresh_temp_1 = LinkBroken02Icon;
$RefreshReg$(_react_refresh_temp_1, "LinkBroken02Icon");
